import React, { useEffect } from 'react';
import CardProfile from '../../../components/Profile/Card/';
import { provideData } from '../../../store/actions/UserAction';
import { connect } from 'react-redux';
import './PremiumMainHolder.scss';

const PremiumMainHolder = ({ authClient, provideData, lawFirmData }) => {

  useEffect(() => {
    provideData(authClient.idLawFirm)
  }, [authClient.idLawFirm, provideData])

  function uniq(a) {
    let prims = {"boolean":{}, "number":{}, "string":{}}, objs = [];
    return a.filter(function(item) {
      let type = typeof item;
      if(type in prims)
        return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
      else
        return objs.indexOf(item) >= 0 ? false : objs.push(item);
    });
  }

  const formatArray = (oldArray) => {
    let outStr = "";
    const arr = uniq(oldArray)
    if (arr.length === 1) {
      outStr = arr[0];
    } else if (arr.length === 2) {
      outStr = arr.join(' y ');
    } else if (arr.length > 2) {
      outStr = arr.slice(0, -1).join(', ') + ' y ' + arr.slice(-1);
    }
    return outStr;
  }

  return (
    <div className='premiumMainHolder'>
      <CardProfile
        title='Titular de despacho'
        subTitle='La información aquí colocada es propia de Contacta Abogado® para ayudar a los clientes a identificar a los abogados. Este dato se mostrará en tu perfil público.'
      >
        <div className="premiumMainHolder_container">
          <p className="premiumMainHolder_paragraph">
            {lawFirmData ?
              `En ${lawFirmData.officeName} contamos con amplia experiencia
              en distintas ramas del Derecho${lawFirmData.specialties && lawFirmData.specialties.length && lawFirmData.specialties.length !== 0 ? ` como son: ${formatArray(lawFirmData.specialties)}.` : '.'}
              ${lawFirmData.states && lawFirmData.states.length !== 0 ?
                `Sabemos de la prontitud con la que las personas necesitan asesoría jurídica,
                por eso ponemos a su disposición nuestros servicios en ${formatArray(lawFirmData.states)}.`
                : ''
              }`
              : ''
            }
          </p>
        </div>
      </CardProfile>
    </div>
  );
};

const mapStateToProps = state => ({
  authClient: state.authClient,
  lawFirmData: state.authClient.lawFirmData
});

const mapDispatchToProps = dispatch => ({
  provideData: (id) => dispatch(provideData(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(PremiumMainHolder);
